import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import EventNavbar from "components/CommonForBoth/EventNavbar"
import UpcomingEvents from "./Events/UpcomingEvents"
import PastEventList from "./Events/PastEventList"

const EventsAuth = props => {
  const { user } = props
  document.title = "Home | PULA Events"
  return (
    <div className="page-content" style={{ paddingLeft: 0, paddingRight: 0 }}>
      <div
        className="container-fluid"
        style={{ paddingLeft: 0, paddingRight: 0 }}
      >
        <UpcomingEvents />
        <PastEventList />
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  user: state.auth.user,
})

EventsAuth.propTypes = {
  t: PropTypes.any,
}

export default connect(mapStateToProps)(EventsAuth)
